// Features: M004-F0799 (WebUI #263, slice C). Tests: T-M004-0432. The group switcher for a customer with more than one open draft.
// Shows each draft's group_label and bill-to display name only. Renders nothing for zero or one draft.
import React from 'react';
import { billToName } from './draftGroups';

export default function DraftGroupSwitcher({ drafts, value, onChange, sentence = '' }) {
  if (!Array.isArray(drafts) || drafts.length < 2) return null;
  return (
    <div className="draft-group-switcher" data-testid="draft-group-switcher">
      {sentence ? <p role="alert" data-testid="draft-selector-sentence">{sentence}</p> : null}
      <label>
        Draft group
        <select aria-label="Draft group" data-testid="draft-group-select" value={value || ''} onChange={(event) => onChange(event.target.value)}>
          {value ? null : <option value="" disabled>Choose a draft</option>}
          {drafts.map((draft) => (
            <option key={draft.invoice_id} value={String(draft.invoice_id)}>
              {draft.group_label}{billToName(draft) ? ` (${billToName(draft)})` : ''}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
